import React, { useState } from 'react';
import { useLang } from '@/utils/i18n';
import { Globe, ChevronDown } from 'lucide-react';

const LANGS = [
  { code: 'de', label: 'DE', flag: 'Deutsch' },
  { code: 'en', label: 'EN', flag: 'English' },
  { code: 'fr', label: 'FR', flag: 'Francais' },
  { code: 'es', label: 'ES', flag: 'Espanol' },
  { code: 'it', label: 'IT', flag: 'Italiano' },
  { code: 'tr', label: 'TR', flag: 'Turkce' },
];

const LangSwitcher = () => {
  const { lang, switchLang } = useLang();
  const [open, setOpen] = useState(false);

  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <div className="relative" data-testid="lang-switcher">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1 px-2 py-1 rounded text-sm text-gray-400 hover:text-white hover:bg-white/5 transition-colors"
      >
        <Globe className="w-3.5 h-3.5" />
        <span className="font-medium">{current.label}</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute right-0 top-9 bg-[#1E1E1E] border border-white/10 rounded-lg shadow-xl overflow-hidden z-50 min-w-[120px]">
          {LANGS.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-${l.code}`}
              onClick={() => { switchLang(l.code); setOpen(false); }}
              className={`w-full text-left px-3 py-2 text-sm hover:bg-white/5 transition-colors flex items-center justify-between ${
                lang === l.code ? 'text-[#00BFA6] font-bold' : 'text-gray-300'
              }`}
            >
              <span>{l.label}</span>
              <span className="text-[10px] text-gray-500">{l.flag}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LangSwitcher;
